<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SubscriptionDelete" });
import { Icon } from "../../../../index.js";
import { createEventDispatcher } from "svelte";
import * as API from "../../services/api.js";
import { addUndo } from "../../../../stores/undo.js";
import { addMessage } from "../../../../stores/messages.js";
export let subscriptionKey;
const dispatch = createEventDispatcher();
const deleteSubscription = async () => {
    if (subscriptionKey === void 0) {
        return;
    }
    const RESPONSE = await API.deleteSubscription({ subscriptionKey });
    if (RESPONSE !== null && "code" in RESPONSE) {
        return;
    }
    addMessage({
        heading: "Subscription deleted successfully.",
        type: "success"
    });
    dispatch("delete");
};
</script>

<Icon
    key = 'delete'
    label = 'Delete'
    on:click = { addUndo.bind(null, {
        action: deleteSubscription,
        label: 'Deleting Subscription',
    })}
/>